// extracted by mini-css-extract-plugin
module.exports = {"weight":"caravanWeight_weight__2TMSJ"};